import api from "./instance";
import { pickData } from "./util";

/**
 * Types
 */

export type Permission =
  | "SETTINGS"
  | "MANAGE_USERS"
  | "BACKUP"
  | "LANGUAGE_CREATE"
  | "LANGUAGE_DELETE"
  | "NS_CREATE"
  | "NS_DELETE"
  | "NS_MODIFY"
  | "ENTRY_CREATE"
  | "ENTRY_DELETE"
  | "ENTRY_MODIFY"
  | "KEY_MODIFY";

export type Credentials = {
  email: string;
  password: string;
};

export type User = {
  id: string;
  email: string;
  name: string;
  permissions: Permission[];
  languages: string[];
};

/**
 * Endpoints
 */

export const login = (creds: Credentials) =>
  api.post<User>("/auth", creds).then(pickData);

export const logout = () => api.post("/auth/logout");

export const me = () => api.get<User>(`/auth/me`).then(pickData);

export const isValid = () =>
  api.get<{ id: string }>("/auth/valid").then(pickData);
